import styled from '@emotion/styled';

const StyledImg = styled.img`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const Container = styled.div<{ isTarget?: boolean }>`
  display: flex;
  gap: 8px;
  padding: 4px;
  border-radius: 4px;
  white-space: nowrap;
  align-items: center;
  background-color: ${({ isTarget }) => isTarget && 'var(--dk-bg-subtle, #F9FAFB)'};
`;
export { StyledImg, Container };
